import axios from 'axios';
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        authObject: null,
        isRegistered: null,
        isLcpUser: null,
        isGetDashboardDataSlow: false, // default to false
        sessionExpired: false,
    },
    getters: {
        getAuthState: s => s.authObject,
        getIsRegistered: s => s.isRegistered,
        getIsLcpUser: s => s.isLcpUser,
        getToken: s => (s.authObject ? s.authObject.access_token : null),
        getSessionExpired: s => s.sessionExpired,
        getIsGetDashboardDataSlow: s => s.isGetDashboardDataSlow,
    },
    actions: {
        checkIfLoggedIn ({ commit }) {
            // look to see if we have a local auth session cookie
            let authResponse = localStorage.getItem('hello');
            if (authResponse && authResponse !== '{}') {
                // we have a local object
                authResponse = JSON.parse(authResponse).adB2CSignInSignUp;
                // check to see if the session is still valid
                if (Vue.moment.unix(authResponse.expires) > Vue.moment()) {
                    commit('setAuthState', authResponse);
                    // set default headers
                    axios.defaults.headers.common.Authorization = `Bearer ${authResponse.access_token}`;
                } else {
                    // clear localstorage, redirect
                    localStorage.removeItem('hello');
                    commit('setAuthState', null);
                    // next('/');
                    return false;
                }
            } else if (authResponse && authResponse === '{}') {
                // clear localstorage, redirect
                localStorage.removeItem('hello');
                commit('setAuthState', null);
                // next('/');
                return false;
            } else if (authResponse === null) {
                return false;
            }
            return true;
        },
        checkIfRegistered ({ commit }, showLoader) {
            const apiUrl = process.env.VUE_APP_APIADDRESS;
            const code = process.env.VUE_APP_APICODE;
            if (showLoader) commit('setLoader', { show: true, message: 'checking our records' }, { root: true });
            return axios.get(`${apiUrl}/isRegistered?code=${code}`)
                .then((response) => {
                    const data = response.data;
                    const isRegistered = data.isRegistered || data.isLcpUser;
                    commit('setIsRegistered', isRegistered);
                    commit('userDetails/setRegisteredStatus', isRegistered, { root: true });
                    commit('setIsLcpUser', data.isLcpUser);
                    commit('setIsGetDashboardDataSlow', data.isGetDashboardDataSlow);
                    if (showLoader) commit('setLoader', { show: false, message: '' }, { root: true });
                    return { isRegistered, isLcpUser: data.isLcpUser, isGetDashboardDataSlow: data.isGetDashboardDataSlow };
                })
                .catch(error => false);
        },
        checkIfPasswordResetRequested () {
            return window.location.href.indexOf('AADB2C901') > -1;
        },
    },
    mutations: {
        setAuthState (state, auth) {
            Vue.set(state, 'authObject', auth);
        },
        setIsRegistered (state, val) {
            Vue.set(state, 'isRegistered', val);
        },
        setIsGetDashboardDataSlow (state, val) {
            Vue.set(state, 'isGetDashboardDataSlow', val);
        },
        setIsLcpUser (state, val) {
            Vue.set(state, 'isLcpUser', val);
        },
        setSessionExpired (state, val) {
            state.sessionExpired = val;
        },
    },
};
